import { render } from "./Warehouses.vue?vue&type=template&id=def85a7c&scoped=true"
import script from "./Warehouses.vue?vue&type=script&lang=js"
export * from "./Warehouses.vue?vue&type=script&lang=js"

import "./Warehouses.vue?vue&type=style&index=0&id=def85a7c&scoped=true&lang=css"

import exportComponent from "/home/cm/project/golinker/admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-def85a7c"]])

export default __exports__